import React from 'react'
import { Link } from 'react-router-dom'

const IdentificationUser = ({ user, _confirmBooking, valuesService, clients, keyUid }) => {
    return ( 
        <div className='mt-3'> 
        {valuesService.hours &&
        <div className='row'>
            <div className='h5 mt-2'>Identification</div>
            <div className='text-center d-grid gap-2 pt-3 shadow'>
                {user.uid ?
                    <>
                        {clients.filter(cl => cl.uid === user.uid).map(cl => (
                            <>
                                <div key={cl.uid} className='text-start'>{cl.surname} {cl.name}</div>
                                <Link to='/authUser' className='btn btn-outline-dark mt-2 mb-4 active rounded-pill' state={{ keyUid:keyUid }} onClick={() => _confirmBooking(cl.uid,cl.id,cl.surname,cl.name,cl.email, cl.token)}>
                                    Confirmer
                                </Link>
                            </>
                        ))}
                    </>
                :
                    <>
                        <div>Nouveau ?</div>
                        <button 
                            className='btn btn-outline-dark mt-2 active rounded-pill' 
                            type='button'
                            data-bs-toggle="modal" 
                            data-bs-target="#createAccountModal"
                        >Créer un compte</button>
                        <div className='mt-2'>Ou</div>
                        <button 
                            className='btn btn-outline-dark mt-2 mb-5 rounded-pill' 
                            type='button'
                            data-bs-toggle="modal" 
                            data-bs-target="#connectModal"
                        >Se connecter</button>
                    </>
                }
            </div>
        </div>
        }
        </div>
    )
}

export default IdentificationUser


